// extracted by mini-css-extract-plugin
module.exports = {"Platforms":"Platforms_Platforms__2zeLR","Platforms__ring":"Platforms_Platforms__ring__3t2qB","Platforms__swiper":"Platforms_Platforms__swiper__4tMqz"};